import React from 'react';
import { Link } from 'react-router-dom';

const PaymentSuccess = () => {
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          top: '50%',
        }}
      >
        <img
          alt="success-icon"
          src="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/wizmonImages/mobileUpload/img_empty_smile.png"
          style={{
            display: 'inline-block',
            width: '150px',
            opacity: '0.9',
            marginBottom: '20px',
          }}
        />
        <p
          style={{
            color: '#848484',
            fontSize: 22,
            marginTop: 15,
          }}
        >
          결제가 완료되었습니다.
        </p>
        <Link to="/mypage/contents-posting-management">
          <button
            style={{
              border: '1px solid #FF7A00',
              borderRadius: 30,
              marginTop: 40,
              backgroundColor: 'white',
              cursor: 'pointer',
              padding: '6px 22px',
              marginBottom: 10,
            }}
          >
            <p style={{ color: '#FF7A00', fontWeight: 'bold' }}>
              콘텐츠 게시관리 페이지 &nbsp;&nbsp;＞
            </p>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;
